import { ShieldCheck, Users, MapPin, Layers } from "lucide-react";

const HIGHLIGHTS = [
    { icon: ShieldCheck, label: "AI Lead Qualification", note: "Assessed by budget, intent & timeline" },
    { icon: Users, label: "OTP verification available", note: "Optional lead-quality tier" },
    { icon: MapPin, label: "Micro-market targeting", note: "Priced on where you actually build" },
    { icon: Layers, label: "Real-estate specialists", note: "Focused only on property" },
];

export default function Achievements() {
    return (
        <section
            data-testid="achievements-section"
            className="py-16 sm:py-20 px-6 sm:px-10 lg:px-16 bg-[#0A0B10] border-y border-[#D4AF37]/20"
        >
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-12">
                    <div className="overline">Built The Right Way</div>
                    <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl leading-tight">
                        Right process. Right partner. <span className="italic text-[#D4AF37]">Right leads.</span>
                    </h2>
                </div>

                <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-4" data-testid="achievements-grid">
                    {HIGHLIGHTS.map((a) => (
                        <div key={a.label} data-testid={`highlight-${a.label.replace(/\s/g, "-").toLowerCase()}`}
                            className="text-center lg:text-left p-6">
                            <a.icon size={18} className="text-[#D4AF37] mx-auto lg:mx-0" strokeWidth={1.5} />
                            <div className="mt-4 font-serif-display text-2xl sm:text-3xl text-white leading-tight">
                                {a.label}
                            </div>
                            <div className="mt-2 text-xs text-white/50">{a.note}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
